import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

export const ACCEPT_USER_INVITATION_MUTATION = gql`
  mutation AcceptUserInvitation($input: AcceptUserInvitationInput!) {
    acceptUserInvitation(input: $input) {
      user {
        id
        email
        fullName
        role
      }
    }
  }
`;

export function useAcceptUserInvitation(options?: { onCompleted?: () => void }) {
  const [acceptInvitationMutation, { loading, error }] = useMutation(ACCEPT_USER_INVITATION_MUTATION, {
    onCompleted: options?.onCompleted,
    onError: (error: any) => {
      const message = error.graphQLErrors?.[0]?.message || error.message || 'Falha ao criar conta';
      toast.error(message);
    },
  });

  const acceptInvitation = (token: string, fullName: string, password: string, passwordConfirmation: string) => {
    return acceptInvitationMutation({
      variables: { input: { token, fullName, password, passwordConfirmation } },
    });
  };

  return { acceptInvitation, loading, error };
}
